
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infographic/[slug]",
      function () {
        return require("private-next-pages/infographic/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infographic/[slug]"])
      });
    }
  